import React from 'react';
import './NewCollections.css';
import Item from '../Item/Item';
import all_products from '../all_product'; 

const NewCollections = () => {
    return (
        <div className="new-collections">
            <h1>Confira nossos Destaques</h1>
            <hr />
            <div className="collections">
                {all_products.length === 0 ? (
                    <p>Nenhuma coleção encontrada</p>
                ) : (
                    all_products.map((item) => (
                        <Item
                            key={item.id}
                            id={item.id}
                            name={item.name}
                            image={item.images[0]} 
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default NewCollections;
